import { getJson } from '../client'
import type { DateRange } from '../params'
import { API } from '../paths'
import {
  queuesHistorySchema,
  queuesSchema,
  type Queues,
  type QueuesHistory,
} from '../schemas/queues'

/** Очереди на кассах (ТЗ п. 5.1, 5.2, 5.4). Границы периода считает фронт, поэтому period=custom с явными from/to. */
export const queuesApi = {
  getCurrent: (): Promise<Queues> => getJson(API.queues.current, queuesSchema),
  getHistory: (params: DateRange): Promise<QueuesHistory> =>
    getJson(API.queues.history, queuesHistorySchema, { params: { period: 'custom', ...params } }),
}
